import { useQuery } from "@tanstack/react-query";
import { getCategorias } from "../../../api";

const useGetCategorias = (produtoId: number = 1) => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['get_categorias', produtoId],
        enabled: true, 
        queryFn: () => getCategorias(produtoId),
        refetchOnWindowFocus: false
    });

    return {
        data,
        isLoading,
        isError,
        error,
    }
};

export default useGetCategorias;